var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.29 18.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2a5b2f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.76,0,.25,8.39a.4.4,0,0,0,0,.73l5.24,2.19L18,3.55a.08.08,0,0,1,.09.12L8.6,12.59,18,18.86a.38.38,0,0,0,.6-.25L22.28.47A.39.39,0,0,0,21.76,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramGreen);
export default __webpack_public_path__ + "static/media/telegram-green.2306364ce4fb5b04a17694128416f191.svg";
export { ForwardRef as ReactComponent };